import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import {Alert, Icon, Layout, Table, Badge, Button, Tooltip, Switch, message, Breadcrumb, Select, Input} from 'antd';

import AdminHeader from '../../components/AdminHeader/AdminHeader';
import Footer from '../../components/Footer/Footer';
import SettingsConsentForm from '../../components/SettingsConsentForm/SettingsConsentForm';
import classes from './SettingsConsent.css';

import isAuthenticated from '../../utils/isAuthenticated';
import { getConsentRequest, deleteConsentRequest, activateConsentRequest } from '../../api/requests';
import { logout } from "../../reducers/user/actions";
import { getConsentCreatePermission, getConsentUpdatePermission, getConsentDeletePermission } from "../../reducers/user/selectors";

const routes = require('../../routes.json');

const { Content } = Layout;

class SettingsConsent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      consentList: [],
      consentFilterState: 'active',
      errorMessage: '',
      responseMessage: '',
      consentEdit: null,
      nameSearch: null,
    };
  }

  async componentDidMount() {
    this.getConsentList();
  }

  getConsentList = async () => {
    this.setState({ errorMessage: null, isLoading: true, responseMessage: null });

    try {
      const { data } = await getConsentRequest({
        nameSearch: this.state.nameSearch,
        stateFilter: this.state.consentFilterState,
      });
      this.setState({ consentList: data });
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
      this.setState({ subject: null, errorMessage: get(e, 'response.data.error', 'Error') });
    }

    this.setState({ isLoading: false });
  };

  columns = [
    {
      dataIndex: "name",
      key: "name",
      title: "Name",
      render: (val, record) => (<span><Badge count={record.state} style={{ width: '56px', backgroundColor: record.state === 'active' ? '#52c41a' : '#777' }} /> &nbsp;{val}</span>)
    },
    // {
    //   dataIndex: "site_id",
    //   key: "site_id",
    //   title: "Site id",
    // },
    {
      dataIndex: "site",
      key: "site",
      title: "Site",
      render: val => (<span>{get(val, 'name')}</span>)
    },
    {
      dataIndex: "applied_to",
      key: "applied_to",
      title: "Applied to",
      render: val => (<span>{val.replace(/_/g, ' ')}</span>)
    },
    {
      dataIndex: "consent_type",
      key: "consent_type",
      title: "Consent type",
      render: val => (<span>{val.replace(/_/g, ' ')}</span>)
    },
    {
      dataIndex: "id",
      key: "id",
      title: "Actions",
      render: (id, consent) => (<div className={classes.actions}>
        <Tooltip placement="topLeft" title="Edit Consent">
          <Icon type="edit" theme="filled" className={classes.actionIcon} onClick={this.onConsentEdit(consent)} />
        </Tooltip>

        <div>
          <b></b><br/>
          <Tooltip placement="topLeft" title="Activate / Deactivate Consent">
            <Switch disabled={(consent.state === 'active' && !this.props.consentDeletePermission) || (consent.state === 'inactive' && !this.props.consentUpdatePermission) } className={classes.activateBtn} checked={consent.state === 'active'} onChange={this.onSwitchConsentActivation(id, consent.state)} />
          </Tooltip>
        </div>
      </div>)
    },
  ];

  onSwitchConsentActivation = (id, state) => async () => {
    try {
      if (state === 'active') {
        await deleteConsentRequest(id);
      } else {
        await activateConsentRequest(id);
      }

      message.success('Saved');

      this.getConsentList();
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
      message.error(get(e, 'response.data.error', 'Error'));
    }
  };

  onConsentEdit = consent => () => {
    this.setState({ consentEdit: consent });
  };

  onConsentEditHide = () => {
    this.setState({ consentEdit: null });
  };

  onConsentEditSubmit = () => {
    this.setState({ consentEdit: null }, this.getConsentList);
  };

  addConsent = () => {
    this.setState({ consentEdit: {} });
  };

  onNameSearch = async (value) => {
    this.setState({ nameSearch: value }, this.getConsentList);
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  clearFilters = () => { this.setState({ nameSearch: null }, this.getConsentList); };


  render() {
    const { consentList, errorMessage, responseMessage, isLoading, consentEdit, nameSearch } = this.state;
    const { consentCreatePermission } = this.props;

    return (
        <div style={{ backgroundColor: '#FAFAFA' }}>
            <Layout className={classes.parentContainer}>
                <AdminHeader />
                <Content className={classes.content}>
                  <h3 className='headline-default'>Consent Management</h3>

                  <Breadcrumb>
                    <Breadcrumb.Item href='/admin/settings'>Admin Settings</Breadcrumb.Item>
                    <Breadcrumb.Item href='/admin/consent/editor'>Consent Management</Breadcrumb.Item>
                  </Breadcrumb>
                  <br/>

                  <div className={classes.searchWrapper}>
                    <label className={classes.searchWrapperSearch}>
                      <b className={classes.searchWrapperLabel}>SEARCH</b>
                      <Input.Search
                        placeholder="By name"
                        enterButton="Search"
                        size="large"
                        onSearch={this.onNameSearch}
                        value={nameSearch}
                        onChange={this.onNameChange}
                        style={{ maxWidth: '500px'}}
                      />
                    </label>

                    <span className={classes.clearButton} onClick={this.clearFilters}>Clear</span>
                  </div>

                  <br/>

                  {!consentEdit && <div>
                    {errorMessage && (<Alert type='error' message={errorMessage} />)}

                    {responseMessage && (<Alert type='success' message={responseMessage} />)}

                    {consentCreatePermission && <div><Button type='primary' onClick={this.addConsent}>Add consent</Button><br/><br/></div>}

                    <div className={classes.filterConsentState}>
                      <b className={classes.searchWrapperLabel}>Show consent with state:</b>
                      <Select
                        defaultValue="active"
                        onChange={(value) => {
                            this.setState({
                              consentFilterState: value,
                            }, () => this.getConsentList());
                          }
                        }
                      >
                        <Select.Option key="state-active" value='active'>
                            Active
                        </Select.Option>
                        <Select.Option key="state-inactive" value='inactive'>
                            Inactive
                        </Select.Option>
                        <Select.Option key="state-all" value=''>
                            All
                        </Select.Option>
                      </Select>
                    </div>


                    <Table
                      columns={this.columns}
                      dataSource={consentList}
                      loading={isLoading}
                      rowKey="id"
                      pagination={false}
                    />
                  </div>}

                  {consentEdit && <SettingsConsentForm {...consentEdit} isNew={consentEdit && !consentEdit.id} onSubmit={this.onConsentEditSubmit} onCancel={this.onConsentEditHide} />}

                </Content>
                <Footer noAdminLink />
            </Layout>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  consentCreatePermission: getConsentCreatePermission(state),
  consentUpdatePermission: getConsentUpdatePermission(state),
  consentDeletePermission: getConsentDeletePermission(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(connect(mapStateToProps, mapDispatchToProps)(SettingsConsent));



// WEBPACK FOOTER //
// ./src/containers/SettingsConsent/SettingsConsent.js